<mat-icon
  class="info-tooltip-icon"
  tabindex="0"
  aria-hidden="false"
  [attr.aria-label]="text()"
  [matTooltip]="text()"
  matTooltipClass="multiline-tooltip"
  matTooltipPosition="above"
  matTooltipShowDelay="200">
  info
</mat-icon>
